import React from 'react';
import { Link } from 'react-router-dom';
import useStyles from './InvestmentsMat';
import { Container, Grid, Typography, Button} from '@mui/material';
import investments31 from '../../assets/investments31.webp';

const FirstSection = ({classes}) => (
    <div className={classes.gradientDiv}>
        <Container maxWidth="lg">
            <Typography variant="h2" className={classes.firstSectionTitle} style={{marginTop:'3em'}}> 
                We only invest if we can lead or co-lead rounds.
            </Typography>
            <Typography variant="h4" className={classes.firstSectionTitle} style={{marginTop:'1em'}}> 
                We won't just write a check. We ask for board seats and dedicate time to secure our founder's success actively.
            </Typography>
            <Button
                component={Link}
                to={'/contact'}
                key={'contact-us-home'}
                variant={'contained'}
                className={classes.buttonContactUs}
            >
                Contact Us
            </Button>
        </Container>
    </div>
)

const SecondSection = ({classes}) =>(
    <Grid
        style={{padding:'4.5rem 0 4.5rem 0'}}
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
    >
        <Grid item xs={10} md={9}>
            <Typography variant="h4" className={classes.secondSectionTitle}> 
            We invest in early-stage companies from pre-seed to series A. Our ticket size usually stands between $250,000 to $2 million.  We participate in multiple rounds if possible.
            </Typography>
        </Grid>
    </Grid>
)

const ThirdSection = ({classes}) =>(
    <Container maxWidth="lg" className={classes.containerThirdSection}>    
        <Grid
            container
            direction="row"
            alignItems="center"
            columnSpacing={{xs:0, md:6}}
            rowSpacing={6}
        >
            <Grid item xs={12} md={6}>
                <img alt="" src={investments31} className={classes.thirdSectionImg} />
            </Grid>
            <Grid item xs={12} md={6}>
                <div className={classes.divFlex}>
                    <Typography variant="h6" className={classes.thirdSectionTitle} style={{marginTop:'3em'}}> 
                    Gea Capital invests its own funds and relies on a solid network of talented investors and successful funds to invest with Us and add value to the founders.  We welcome industry expert co-investors that make our board more robust and help us guide the company to regional success.
                    </Typography>
                </div>
            </Grid>
        </Grid>
    </Container>
)


const Investments = () =>{

    const classes = useStyles();   

    return(
        <>
            <FirstSection classes={classes}/>
            <SecondSection classes={classes}/>
            <ThirdSection classes={classes}/>
        </>
    );
}
export default Investments;